<!-- Modal (Com Bonificação) -->

<ng-template #comBonificacao let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-com-bonificacao"><b>Bonificação</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="text-center">
      <h5><b>Bonificação gerada! Deseja alterar pedido gerado?</b></h5>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="d-flex justify-content-between">
      <div>
        <h6 class="text-secondary"><b>Número:</b></h6>
        <h6><b>{{ pedidoBonificacaoRetorno.numero_pedido_bonificado }}</b></h6>
      </div>

      <div class="text-right">
        <h6 class="text-secondary"><b>Bonificação: R$</b></h6>
        <h6><b>{{ pedidoBonificacaoRetorno.valor_pedido_bonificado | currency: 'BRL' }}</b></h6>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Nao')">Não</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Sim')">Sim</button>
  </div>
</ng-template>

<!-- Modal (Desconto Simulado) -->

<ng-template #descontoSimulado let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-desconto-simulado"><b>Desconto Simulado</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group offset-4 col-sm-4">
          <label><b>Desconto: %</b></label>

          <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="descontoSimulado" (focusout)="validarDescontoSimulado()" (input)="validarDescontoSimulado()" [ngClass]="{ 'is-invalid': porcentagemDescontoSimuladoErro }" [(ngModel)]="porcentagemDescontoSimulado" />

          @if (porcentagemDescontoSimuladoErro) {
            <div class="erro pt-1">Desconto inválido!</div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Prosseguir')">Prosseguir</button>
  </div>
</ng-template>

<!-- Modal (Enviar) -->

<ng-template #enviarPedidos let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pedido-enviar"><b>Enviar</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group offset-3 col-sm-3">
        <label><b>Desconto Máximo: %</b></label>

        <input class="form-control form-control-sm" type="text" name="desconto" [value]="prazoMedioDesconto == null ? '': prazoMedioDesconto.percentual_desconto" disabled />
      </div>

      <div class="form-group col-sm-3">
        <label><b>Desconto Aplicado: %</b></label>

        <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="descontoAplicado" (focusout)="validarDescontoAplicado()" (input)="validarDescontoAplicado()" [ngClass]="{ 'is-invalid': porcentagemDescontoAplicadoErro }" [(ngModel)]="porcentagemDescontoAplicado" />

        @if (porcentagemDescontoAplicadoErro) {
          <div class="erro pt-1">Desconto Aplicado inválido!</div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Enviar')">Enviar</button>
  </div>
</ng-template>

<!-- Modal (Status) -->

<ng-template #pedidoStatus let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pedido-status"><b>Status (Pedido)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th class="text-center">Data</th>
            <th class="tabela_borda">Observação</th>
          </tr>
        </thead>

        <tbody>
          @for (pedidoStatus of pedidosStatus; track pedidoStatus) {
            <tr>
              <td class="text-center">{{ pedidoStatus.data | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="tabela_borda">{{ pedidoStatus.obs }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
  <!-- Filtro -->

  <form [formGroup]="formFiltro" (ngSubmit)="filtrar(true)">
    <div class="form-row">
      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Filtrar por:</b></label>

        <select class="form-control form-control-sm" name="filtrar_pendencias_por" formControlName="filtro" (change)="alterarFiltro($event.target.value)">
          @for (opcao of filtroOpcoes; track opcao) {
            <option [value]="opcao.valor" [selected]="opcao.valor == f.filtro.value">{{ opcao.texto }}</option>
          }
        </select>
      </div>

      <!-- Período (Criado) -->

      @if (f.filtro.value == 0) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Dt. Inicial:</b></label>
          <input class="form-control form-control-sm" type="text" name="pendencias_filtrar_dt_inicial" ngbDatepicker #dt_inicial="ngbDatepicker" (click)="dt_inicial.toggle()" [ngClass]="{ 'is-invalid': enviado && f.dt_inicial.errors?.required }" formControlName="dt_inicial" />
          @if (enviado && f.dt_inicial.errors?.required) {
            <div class="erro pt-1">Dt. Inicial em branco!</div>
          }
        </div>
      }

      @if (f.filtro.value == 0) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Dt. Final:</b></label>
          <input class="form-control form-control-sm" type="text" name="pendencias_filtrar_dt_final" ngbDatepicker #dt_final="ngbDatepicker" (click)="dt_final.toggle()" [ngClass]="{ 'is-invalid': enviado && f.dt_final.errors?.required }" formControlName="dt_final" />
          @if (enviado && f.dt_final.errors?.required) {
            <div class="erro pt-1">Dt. Final em branco!</div>
          }
        </div>
      }

      <!-- Cliente -->

      @if (f.filtro.value == 1) {
        <div class="form-group col-sm-4">
          <label class="text-secondary"><b>Cliente:</b></label>
          <input class="form-control form-control-sm" type="text" name="pendencias_filtrar_cliente" [ngClass]="{ 'is-invalid': enviado && f.cliente.errors?.required }" formControlName="cliente" />
          @if (enviado && f.cliente.errors?.required) {
            <div class="erro pt-1">Cliente em branco!</div>
          }
        </div>
      }

      <!-- Nro Pedido -->

      @if (f.filtro.value == 2) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro Pedido:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="pendencias_filtrar_nro_pedido" [ngClass]="{ 'is-invalid': enviado && f.nro_pedido.errors?.required }" formControlName="nro_pedido" />
          @if (enviado && f.nro_pedido.errors?.required) {
            <div class="erro pt-1">Nro Pedido em branco!</div>
          }
        </div>
      }

      <!-- Status -->

      @if (f.filtro.value == 3) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Status:</b></label>
          <select class="form-control form-control-sm" name="pendencias_status" formControlName="status">
            @for (opcao of filtroStatus; track opcao) {
              <option [value]="opcao.valor" [selected]="opcao.valor == f.status.value">{{ opcao.texto }}</option>
            }
          </select>
          @if (enviado && f.status.errors?.required) {
            <div class="erro pt-1">Status em branco!</div>
          }
        </div>
      }

      <!-- Vendedor(a) -->

      <div class="form-group col-sm-3">
        <label class="text-secondary"><b>Vendedor(a):</b></label>

        <app-vendedor-typeahead
          [vendedorSelecionado]="f.vendedor.value"
          (vendedorChange)="f.vendedor.setValue($event)">
        </app-vendedor-typeahead>
      </div>

      <div class="col-sm-3">
        <div class="btn_filtro_grupo">
          <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>

          @if (filtrado) {
            <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltro(null)">Cancelar</button>
          }
          @if (orcamentos.length > 0 && (is_master || is_manager || is_diretor || is_financeiro)) {
            <button
              class="btn btn-success btn_filtro"
              type="button"
              (click)="exportarExcel()"
              [disabled]="excelExportando">
              {{ excelExportando ? 'Gerando...' : 'Exportar Excel' }}
            </button>
          }
          @if (orcamentos.length > 0 && is_diretor) {
            <button
              class="btn btn-warning btn_filtro"
              type="button"
              (click)="exportarExcelDiretoria()"
              [disabled]="excelDiretoriaExportando">
              {{ excelDiretoriaExportando ? 'Gerando...' : 'Excel Diretoria' }}
            </button>
          }
        </div>
      </div>
    </div>
  </form>

  <!-- Modelo 1 -->

  @if (modelo_tela_ligacoes == 0) {
    <div class="table-responsive">
      <div class="tabela_paginada">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="text-center tabela_borda">Status</th>
              <th class="text-center tabela_borda">Nro Pedido</th>
              <th class="tabela_borda">Vend Externo</th>
              <th class="tabela_borda">Vend Interno</th>
              <th class="tabela_borda">Cliente</th>
              <th class="text-center tabela_borda">CNPJ/CPF</th>
              <th class="text-right tabela_borda">Total: R$</th>
              <th class="text-right tabela_borda">Litragem</th>
              <th class="tabela_borda">Prazo Pagto</th>
              <th class="text-center tabela_borda">Tipo</th>
              <th class="text-center tabela_borda">Criado</th>
              <th class="text-center tabela_borda">Dt. Validade</th>
            </tr>
          </thead>
          <tbody>
            @for (orcamento of orcamentos; track orcamento; let i = $index) {
              <tr [ngClass]="orcamento.order_id_app.toString().substring(0, 3) == '130' ? 'bg_tabela_info' : ''">
                <td class="text-center tabela_acao">
                  <i class="fa btn_tabela_acao" [ngClass]="i == itemExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandir(i, orcamento.order_id_app, orcamento.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desativar" (click)="desativar(orcamento.order_id_app, orcamento.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-file btn_tabela_acao" placement="right" ngbTooltip="PDF" (click)="modalDescontoSimulado(descontoSimulado, orcamento.order_id_app, orcamento.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  @if (orcamento.status_pedido == 'Reprovado') {
                    <i class="fa fa-info btn_tabela_acao" placement="right" ngbTooltip="Status" (click)="modalPedidoStatus(pedidoStatus, orcamento.order_id_app)"></i>
                  }
                </td>
                <td class="text-center tabela_borda">
                  @if (orcamento.pendencia && !orcamento.pendencia_ok) {
                    <span class="badge badge-orange">Pendência</span>
                  }
                  @if (orcamento.pendencia && orcamento.pendencia_ok) {
                    <span class="badge badge-orange-light">Pendência OK</span>
                  }
                  <!-- <span class="badge badge-dark" *ngIf="orcamento.status_pedido == 'Reprovado'">{{ orcamento.status_pedido }}</span>
                  <span class="badge badge-secondary" *ngIf="orcamento.status_pedido != 'Pendência' && orcamento.status_pedido != 'Não Enviado' && orcamento.status_pedido != 'Reprovado'">{{ orcamento.status_pedido }}</span> -->
                </td>
                <td class="text-center tabela_borda">{{ orcamento.order_id_app }}</td>
                <td class="tabela_borda">{{ orcamento.vend_ext }}</td>
                <td class="tabela_borda">{{ orcamento.vend_int }}</td>
                <td class="tabela_borda">{{ orcamento.name }}</td>
                <td class="text-center tabela_borda">{{ orcamento.client_document }}</td>
                <td class="text-right tabela_borda">{{ orcamento.total | currency: 'BRL' }}</td>
                <td class="text-right tabela_borda">{{ orcamento.total_litragem | currency: 'BRL' }}</td>
                <td class="tabela_borda">{{ orcamento.prazo_pgto }}</td>
                <td class="text-center tabela_borda">{{ orcamento.cod_tipopedvenda }}</td>
                <td class="text-center tabela_borda">{{ orcamento.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="text-center tabela_borda">{{ orcamento.dt_validade | date: 'dd/MM/yyyy' }}</td>
              </tr>
              @if (i == itemExpandido) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" colspan="12">
                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Código</th>
                            <th class="tabela_borda">Descrição</th>
                            <th class="text-center tabela_borda">Qtde</th>
                            <th class="text-right tabela_borda">Estoque</th>
                            <th class="text-right tabela_borda">Unitário: R$</th>
                            @if (exibirFatorFinanceiro) {
                              <th class="text-right tabela_borda">Fator: R$</th>
                            }
                            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                              <th class="text-right tabela_borda">Imposto: R$</th>
                            }
                            @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                              <th class="text-right tabela_borda">Unitário (Final): R$</th>
                            }
                            <th class="text-right tabela_borda">Sub-Total: R$</th>
                            @if (is_master || is_manager || is_diretor) {
                              <th class="text-right tabela_borda">Margem: %</th>
                            }
                            <th class="text-right tabela_borda">Tabela: R$</th>
                            <th class="tabela_borda">Promoção</th>
                            <th class="text-right tabela_borda">Preço Promoção: R$</th>
                            <th class="text-right tabela_borda">Desconto: R$</th>
                            <th class="text-right tabela_borda">Desconto: %</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *cdkVirtualFor="let orcamentoItem of orcamentosItens; templateCacheSize: 0;">
                            <tr>
                              <td class="text-center">{{ orcamentoItem.referencia_cliente }}</td>
                              <td class="tabela_borda">{{ orcamentoItem.produto }}</td>
                              <td class="text-center tabela_borda">{{ orcamentoItem.quantity }}</td>
                              <td class="text-right tabela_borda">
                                <span [ngClass]="isItemPendente(orcamentoItem) ? 'item_pendente' : ''">
                                  {{ orcamentoItem.estoque_disponivel != null ? orcamentoItem.estoque_disponivel : '-' }}
                                </span>
                              </td>
                              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(orcamentoItem.vr_unitario_original) }}</td>
                              @if (exibirFatorFinanceiro) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.fator_financeiro | currency: 'BRL' }}</td>
                              }
                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.valor_imposto | currency: 'BRL' }}</td>
                              }
                              @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.vr_unitario_acumulado | currency: 'BRL' }}</td>
                              }
                              <td class="text-right tabela_borda">{{ orcamentoItem.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                              @if (is_master || is_manager || is_diretor) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.mkt | currency: 'BRL' : '' }}%</td>
                              }
                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.preco_tabela | currency: 'BRL' }}</td>
                              }
                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.precotabela2 | currency: 'BRL' }}</td>
                              }
                              <td class="tabela_borda">{{ orcamentoItem.nome_promocao }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItem.preco_tabela | currency: 'BRL' }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItem.valor_desconto | currency: 'BRL' }}</td>
                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.desc_aplicado | currency: 'BRL' : '' }}%</td>
                              }
                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ orcamentoItem.desc_aplicado2 | currency: 'BRL' : '' }}%</td>
                              }
                            </tr>
                            @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && orcamentoItem.observacao_item != null && orcamentoItem.observacao_item != '') {
                              <tr>
                                <td></td>
                                <td class="tabela_borda" colspan="15">
                                  {{ orcamentoItem.observacao_item }}
                                </td>
                              </tr>
                            }
                          </ng-container>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            @if (exibirFatorFinanceiro) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            <td class="tabela_borda_inferior"></td>
                            @if (is_master || is_manager || is_diretor) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_itens_valor_saldo tabela_borda_inferior text-right"><b>Saldo: R$</b></td>
                            <td class="tabela_borda_inferior tabela_borda text-right">
                              @if (orcamentosItensSaldo < 0) {
                                <span class="badge badge-danger">{{ orcamentosItensSaldo | currency: 'BRL' }}</span>
                              }
                              @if (orcamentosItensSaldo == 0) {
                                <span class="badge badge-primary">{{ orcamentosItensSaldo | currency: 'BRL' }}</span>
                              }
                              @if (orcamentosItensSaldo > 0) {
                                <span class="badge badge-success">{{ orcamentosItensSaldo | currency: 'BRL' }}</span>
                              }
                            </td>
                            <td class="tabela_borda_inferior tabela_borda"></td>
                          </tr>
                          @if (orcamento.observacao_interna != null && orcamento.observacao_interna != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="14"><b>Observação Interna:</b> {{ orcamento.observacao_interna }}</td>
                            </tr>
                          }
                          @if (orcamento.observacao_nf != null && orcamento.observacao_nf != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="14"><b>Observação Nota Fiscal:</b> {{ orcamento.observacao_nf }}</td>
                            </tr>
                          }
                        </tfoot>
                      </table>
                    </cdk-virtual-scroll-viewport>
                  </td>
                  @if (orcamentosItens.length > 0) {
                    <td class="pt-3 pb-3" colspan="4">
                      <div class="text-center p-0">
                        <div class="tabela_itens_valor_total"><b>Valor Total: {{ orcamentosItens[0].vr_total_acumulado | currency: 'BRL' }}</b></div>
                      </div>
                      <div class="text-center p-0">
                        @if (is_master || is_manager || is_diretor) {
                          <div class="tabela_itens_valor_margem"><b>Margem: {{ orcamentosItens[0].mkt_pedido | currency: 'BRL' : '' }}%</b></div>
                        }
                      </div>
                      @if ((is_master || is_diretor) && orcamento.status_pedido == 'Não Enviado') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="modalPedidoEnviar(enviarPedidos, orcamento.order_id_app, orcamento.seller_id, orcamento.selleridclient, false)">Enviar</button>
                        </div>
                      }
                      @if (is_master || is_diretor) {
                        <div class="text-center pt-2">
                          <button class="btn btn-secondary btn_tabela" (click)="alterar(orcamento.order_id_app, orcamento.seller_id)">Alterar</button>
                          <button class="btn btn-secondary btn_tabela" (click)="duplicar(orcamento.order_id_app, orcamento.seller_id)">Duplicar</button>
                        </div>
                      }
                    </td>
                  }
                </tr>
              }
              @if (i == itemExpandido && orcamentosItensBonificacao.length > 0) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="text-center" colspan="10">
                    <b>Bonificação Vinculada</b>
                  </td>
                </tr>
              }
              @if (i == itemExpandido && orcamentosItensBonificacao.length > 0) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" colspan="10">
                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Código</th>
                            <th class="tabela_borda">Descrição</th>
                            <th class="text-center tabela_borda">Qtde</th>
                            <th class="text-right tabela_borda">Unitário: R$</th>
                            <th class="text-right tabela_borda">Total: R$</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *cdkVirtualFor="let orcamentoItemBonificacao of orcamentosItensBonificacao; templateCacheSize: 0;">
                            <tr>
                              <td class="text-center">{{ orcamentoItemBonificacao.referencia_cliente }}</td>
                              <td class="tabela_borda">{{ orcamentoItemBonificacao.produto }}</td>
                              <td class="text-center tabela_borda">{{ orcamentoItemBonificacao.quantity }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItemBonificacao.unit_price | currency: 'BRL' }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItemBonificacao.total | currency: 'BRL' }}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </cdk-virtual-scroll-viewport>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <!-- Modelo 2 -->

  @if (modelo_tela_ligacoes == 1) {
    <div class="table-responsive">
      <div class="tabela_paginada">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="text-center tabela_borda">Status</th>
              <th class="text-center tabela_borda">Nro Pedido</th>
              <th class="tabela_borda">Cliente</th>
              <th class="text-right tabela_borda">Total: R$</th>
              <th class="text-right tabela_borda">Volume Total: R$</th>
              <th class="text-center tabela_borda">Data do Pedido</th>
              <th class="tabela_borda">Prazo Pagto</th>
              <th class="text-center tabela_borda">Tipo</th>
              <th class="text-center tabela_borda">Nota Fiscal</th>
            </tr>
          </thead>
          <tbody>
            @for (orcamento of orcamentos; track orcamento; let i = $index) {
              <tr>
                <td class="text-center tabela_acao">
                  <i class="fa btn_tabela_acao" [ngClass]="i == itemExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandir(i, orcamento.order_id_app, orcamento.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desativar" (click)="desativar(orcamento.order_id_app, orcamento.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-file btn_tabela_acao" placement="right" ngbTooltip="PDF" (click)="modalDescontoSimulado(descontoSimulado, orcamento.order_id_app, orcamento.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  @if (orcamento.status_pedido == 'Reprovado') {
                    <i class="fa fa-info btn_tabela_acao" placement="right" ngbTooltip="Status" (click)="modalPedidoStatus(pedidoStatus, orcamento.order_id_app)"></i>
                  }
                </td>
                <td class="text-center tabela_borda">
                  @if (orcamento.status_pedido == 'Pendência') {
                    <span class="badge badge-warning">{{ orcamento.status_pedido }}</span>
                  }
                  @if (orcamento.status_pedido == 'Não Enviado') {
                    <span class="badge badge-primary">{{ orcamento.status_pedido }}</span>
                  }
                  @if (orcamento.status_pedido == 'Reprovado') {
                    <span class="badge badge-dark">{{ orcamento.status_pedido }}</span>
                  }
                  @if (orcamento.status_pedido != 'Pendência' && orcamento.status_pedido != 'Não Enviado' && orcamento.status_pedido != 'Reprovado') {
                    <span class="badge badge-secondary">{{ orcamento.status_pedido }}</span>
                  }
                </td>
                <td class="text-center tabela_borda">{{ orcamento.id_no_erp_do_cliente }}</td>
                <td class="tabela_borda">{{ orcamento.name }}</td>
                <td class="text-right tabela_borda">{{ orcamento.total | currency: 'BRL' }}</td>
                <td class="text-right tabela_borda">{{ orcamento.total_volume | currency: 'BRL' }}</td>
                <td class="text-center tabela_borda">{{ orcamento.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="tabela_borda">{{ orcamento.prazo_pgto }}</td>
                <td class="text-center tabela_borda">{{ orcamento.cod_tipopedvenda }}</td>
                <td class="text-center tabela_borda">{{ orcamento.numero_nf }}</td>
              </tr>
              @if (i == itemExpandido) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" colspan="9">
                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Código</th>
                            <th class="text-center tabela_borda">Sku</th>
                            <th class="tabela_borda">Descrição</th>
                            <th class="tabela_borda">Marca</th>
                            <th class="text-center tabela_borda">Qtde</th>
                            <th class="text-right tabela_borda">Estoque</th>
                            <th class="text-right tabela_borda">Unitário: R$</th>
                            <th class="text-right tabela_borda">Total: R$</th>
                            <th class="text-right tabela_borda">Volume: R$</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *cdkVirtualFor="let orcamentoItem of orcamentosItens; templateCacheSize: 0;">
                            <tr>
                              <td class="text-center">{{ orcamentoItem.codigo }}</td>
                              <td class="text-center tabela_borda">{{ orcamentoItem.referencia_cliente }}</td>
                              <td class="tabela_borda">{{ orcamentoItem.produto }}</td>
                              <td class="tabela_borda">{{ orcamentoItem.grupo_estoque }}</td>
                              <td class="text-center tabela_borda">{{ orcamentoItem.quantity }}</td>
                              <td class="text-right tabela_borda">
                                <span [ngClass]="isItemPendente(orcamentoItem) ? 'item_pendente' : ''">
                                  {{ orcamentoItem.estoque_disponivel != null ? orcamentoItem.estoque_disponivel : '-' }}
                                </span>
                              </td>
                              <td class="text-right tabela_borda">{{ orcamentoItem.vr_unitario_original | currency: 'BRL' }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItem.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItem.volume | currency: 'BRL' }}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                        <tfoot>
                          @if (orcamento.observacao_interna != null && orcamento.observacao_interna != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Interna:</b> {{ orcamento.observacao_interna }}</td>
                            </tr>
                          }
                          @if (orcamento.observacao_nf != null && orcamento.observacao_nf != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Nota Fiscal:</b> {{ orcamento.observacao_nf }}</td>
                            </tr>
                          }
                        </tfoot>
                      </table>
                    </cdk-virtual-scroll-viewport>
                  </td>
                  @if (orcamentosItens.length > 0) {
                    <td class="pt-3 pb-3" colspan="4">
                      <div class="text-center p-0">
                        <div class="tabela_itens_valor_total"><b>Valor Total: {{ orcamentosItens[0].vr_total_acumulado | currency: 'BRL' }}</b></div>
                      </div>
                      <div class="text-center p-0">
                        @if (is_master || is_manager || is_diretor) {
                          <div class="tabela_itens_valor_margem"><b>Margem: {{ orcamentosItens[0].mkt_pedido | currency: 'BRL' : '' }}%</b></div>
                        }
                      </div>
                      @if ((is_master || is_diretor) && orcamento.status_pedido == 'Não Enviado') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="modalPedidoEnviar(enviarPedidos, orcamento.order_id_app, orcamento.seller_id, orcamento.selleridclient, false)">Enviar</button>
                        </div>
                      }
                      @if (is_master || is_diretor) {
                        <div class="text-center pt-2">
                          <button class="btn btn-secondary btn_tabela" (click)="alterar(orcamento.order_id_app, orcamento.seller_id)">Alterar</button>
                          <button class="btn btn-secondary btn_tabela" (click)="duplicar(orcamento.order_id_app, orcamento.seller_id)">Duplicar</button>
                        </div>
                      }
                    </td>
                  }
                </tr>
              }
              @if (i == itemExpandido && orcamentosItensBonificacao.length > 0) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="text-center" colspan="12">
                    <b>Bonificação Vinculada</b>
                  </td>
                </tr>
              }
              @if (i == itemExpandido && orcamentosItensBonificacao.length > 0) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" colspan="12">
                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Código</th>
                            <th class="tabela_borda">Descrição</th>
                            <th class="text-center tabela_borda">Qtde</th>
                            <th class="text-right tabela_borda">Unitário: R$</th>
                            <th class="text-right tabela_borda">Total: R$</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *cdkVirtualFor="let orcamentoItemBonificacao of orcamentosItensBonificacao; templateCacheSize: 0;">
                            <tr>
                              <td class="text-center">{{ orcamentoItemBonificacao.referencia_cliente }}</td>
                              <td class="tabela_borda">{{ orcamentoItemBonificacao.produto }}</td>
                              <td class="text-center tabela_borda">{{ orcamentoItemBonificacao.quantity }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItemBonificacao.unit_price | currency: 'BRL' }}</td>
                              <td class="text-right tabela_borda">{{ orcamentoItemBonificacao.total | currency: 'BRL' }}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </cdk-virtual-scroll-viewport>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <app-pagination
    [page]="page"
    [totalPages]="totalPages"
    [totalItems]="total"
    [pageSize]="pageSize"
    [pageSizes]="[20, 50, 100]"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
  </app-pagination>
</div>
